export const schoolsMenuData = [
  {
    id: 1,
    code: "AI",
    url: "/courses/ai-automation-diploma",
    title: "AI Automation",
    desc: "Agents, workflows and intelligent systems",
    codeColor: "#825600",
    codeBg: "#fff4d7",
  },
  {
    id: 2,
    code: "CS",
    url: "/courses/cybersecurity-bootcamp",
    title: "Cyber Security",
    desc: "Security operations, risk and protection",
    codeColor: "#12643d",
    codeBg: "#edf9f3",
  },
  {
    id: 3,
    code: "DA",
    url: "/courses/data-analytics-bootcamp",
    title: "Data Analytics",
    desc: "Excel, SQL and Power BI for data-driven decisions",
    codeColor: "#050794",
    codeBg: "#e9efff",
  },
  {
    id: 4,
    code: "DS",
    url: "/courses/data-science-bootcamp",
    title: "Data Science",
    desc: "Python, machine learning and predictive modelling",
    codeColor: "#050794",
    codeBg: "#e9efff",
  },
  {
    id: 5,
    code: "MBA",
    url: "/mba",
    title: "Global MBA",
    desc: "Global leadership with university partners",
    featured: true,
  },
  {
    id: 6,
    code: "PD",
    url: "/courses/product-management-and-design-bootcamp",
    title: "Product and Design",
    desc: "Strategy, UX and product delivery",
    codeColor: "#5b35c4",
    codeBg: "#f1ebff",
  },
  {
    id: 7,
    code: "BA",
    url: "/courses/business-analysis-bootcamp",
    title: "Business Analysis and Project Management",
    desc: "Requirements, change and confident delivery",
    codeColor: "#9a4300",
    codeBg: "#fff0e7",
  },
];
